export default __webpack_public_path__ + "static/media/bu-syela.8d7bd835.png";